/* Share the existing article's cookie-notice preference across both pages. */
(function () {
  'use strict';
  var bar = document.getElementById('oc-cookie-notice');
  var accept = document.getElementById('oc-cookie-accept');
  if (!bar || !accept) return;
  var key = 'odor_crush_cookie_ok';
  var accepted = false;
  function refresh() {
    try { accepted = window.localStorage.getItem(key) === '1'; } catch (error) {}
    bar.hidden = accepted;
  }
  accept.addEventListener('click', function () {
    accepted = true;
    bar.hidden = true;
    try { window.localStorage.setItem(key, '1'); } catch (error) {}
  });
  window.addEventListener('pageshow', refresh);
  window.addEventListener('storage', function (event) {
    if (event.key === key || event.key === null) refresh();
  });
  refresh();
})();
